var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "url(#paint0_linear_5493_85395)",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#332D39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 11.8334H11.0007C10.5586 11.8334 10.1347 12.009 9.82214 12.3215C9.50958 12.6341 9.33398 13.058 9.33398 13.5V21C9.33398 21.4421 9.50958 21.866 9.82214 22.1785C10.1347 22.4911 10.5586 22.6667 11.0007 22.6667H18.5007C18.9427 22.6667 19.3666 22.4911 19.6792 22.1785C19.9917 21.866 20.1673 21.4421 20.1673 21V20.1667M19.334 10.1667L21.834 12.6667M22.9882 11.4875C23.3164 11.1593 23.5007 10.7142 23.5007 10.25C23.5007 9.78588 23.3164 9.34073 22.9882 9.01253C22.6599 8.68432 22.2148 8.49994 21.7507 8.49994C21.2865 8.49994 20.8414 8.68432 20.5132 9.01253L13.5007 16V18.5H16.0007L22.9882 11.4875Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5493_85395",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67308F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/editDark.103e86e079784b66e2edd8ee6fdbff29.svg";
export { ForwardRef as ReactComponent };